import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "react-multi-carousel/lib/styles.css";
import { Box, Grid, Typography } from "@mui/material";
import Slider from "react-slick";
import { useCardLayout } from "./CardLayoutHooks";
import { SlickArrow } from "./CustomComponents";
import { makeStyles } from "@mui/styles";
import { useEffect, useRef } from "react";
const useStyles = makeStyles((theme) => {
    return {
        slider: {
            "& .slick-track": {
                display: "flex",
                "& .slick-slide": {
                    height: "auto",
                    alignItems: "stretch",
                    display: "flex",
                    // Left and right padding are larger to stop the elevation of a selected element from showing on the next page.
                    padding: theme.spacing(0.5, 1, 0.5, 1),
                    "&>div": {
                        width: "100%",
                    },
                },
            },
        },
    };
});
/**
 * CardLayout - This displays items in either a Grid or Slider view. Uses "Cards Per Row" module configurations.
 * This uses the existing Slick slider.
 * @param props - isGridLayout, gridSpacing, cardsPerRowLG...
 * @returns Grid or Slider view
 */
export const CardLayout = (props) => {
    const sliderRef = useRef(null);
    const { isGridLayout, cardsToRender, sliderSettings, cardsPerRowXS, cardsPerRowSM, cardsPerRowMD, cardsPerRowLG, gridSpacing, headerText, CenterCards, } = props;
    // See README.md in the CardLayout directory for information about the justifyContent value.
    const { xs, sm, md, lg, justifyContent } = useCardLayout(cardsPerRowXS, cardsPerRowSM, cardsPerRowMD, cardsPerRowLG, cardsToRender === null || cardsToRender === void 0 ? void 0 : cardsToRender.length, CenterCards);
    const classes = useStyles();
    // React Slick has known quirks with dynamically generated content and responsiveness,
    // such as improperly calculated widths during the initial render.
    // This can lead to visual issues, such as empty slides or incorrect alignment.
    useEffect(() => {
        // Ensure the slider resets to the first slide whenever the number of cards to render changes.
        // This is particularly useful when the data updates dynamically, ensuring proper rendering
        // and avoiding display issues caused by slider misalignment or incorrect calculations.
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(0); // Programmatically navigate to the first slide.
        }
    }, [cardsToRender === null || cardsToRender === void 0 ? void 0 : cardsToRender.length]); // Dependency ensures this effect runs only when the number of cards changes.
    return (_jsxs(Box, Object.assign({ sx: { maxWidth: 1 } }, { children: [!!headerText && _jsx(Typography, { children: headerText }), !isGridLayout ? (
            //Next and prev arrows being hidden is a known issue with react-slick
            _jsx(Box, Object.assign({ px: 3 }, { children: _jsx(Slider, Object.assign({ ref: sliderRef, nextArrow: _jsx(SlickArrow, { type: "next" }), prevArrow: _jsx(SlickArrow, { type: "prev" }), className: classes.slider }, sliderSettings, { children: cardsToRender === null || cardsToRender === void 0 ? void 0 : cardsToRender.map((card) => card) })) }))) : (_jsx(Grid, Object.assign({ container: true, spacing: gridSpacing, justifyContent: justifyContent }, { children: cardsToRender === null || cardsToRender === void 0 ? void 0 : cardsToRender.map((card, index) => {
                    return (_jsx(Grid, Object.assign({ item: true, xx: xs, sm: sm, md: md, lg: lg }, { children: card }), `${card.key}-${index}`));
                }) })))] })));
};
